<template>
  <div>
    <div class="container-fluid">
      <div class="page-header">
        <div class="row">
          <div class="col-sm-6">
            <h3>{{$t("appspecificdata")}}</h3>
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a>{{$t("management")}}</a></li>
              <li class="breadcrumb-item active">{{$t("appspecificdata_management")}}</li>
            </ol>
          </div>
          <div class="col-sm-6">
            <!-- Bookmark Start-->
            <div class="bookmark">
              <ul>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Tables"><i data-feather="inbox"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Chat"><i data-feather="message-square"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Icons"><i data-feather="command"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Learning"><i data-feather="layers"></i></a></li>
                <li><a href="javascript:void(0)"><i class="bookmark-search" data-feather="star"></i></a>
                  <form class="form-inline search-form">
                    <div class="form-group form-control-search">
                      <input type="text" :placeholder="$t('search') + '...'">
                    </div>
                  </form>
                </li>
              </ul>
            </div>
            <!-- Bookmark Ends-->
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="col-md-12 p-0 project-list">
        <div class="card">
          <div class="row">
            <div class="col-md-6 p-0">
              <div class="mb-2">
                <input class="form-control" type="text" v-model="search" @change="fetchApps(true)" :placeholder="$t('search') + '...'">
              </div>
            </div>
            <div class="col-md-6 p-0">
              <div class="form-group mb-0 me-0"></div>
              <a class="btn btn-primary-light" @click="$router.push('/create-appspecifics')"> <plus-square-icon
                  class="custom-class"></plus-square-icon>{{$t("CREATE_NEW_DATA")}}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">{{$t("app")}}</th>
                    <th scope="col">{{$t("name")}}</th>
                    <th scope="col">{{$t("actions")}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="appspecific in appspecificdata" :key="appspecific.id">
                    <td class="align-middle"><v-img class="rounded-lg" :src="`/files/images/${appspecific.app.icon}`" width="50" :aspect-ratio="1"></v-img>
                    </td>
                    <td class="align-middle"> {{ appspecific.namesMap[$locale] }}</td>
                    <td class="align-middle">
                      <button class="btn btn-light" @click="$router.push('/edit-appspecifics?appspecificdataId=' + appspecific.id)">
                        <edit-icon size="16"></edit-icon></button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="position:absolute; bottom: 100px;left:50%;height:40px;width:40px "
      v-intersect.quiet="infiniteScrolling"></div>
    <!-- Container-fluid Ends-->

  </div>
</template>

<script>

import pagination from './custom/pagination.vue'
import { MapPinIcon, PlusSquareIcon, ClipboardIcon, FileTextIcon, TrashIcon, EditIcon } from 'vue-feather-icons'

export default {

  components: {
    MapPinIcon,
    PlusSquareIcon,
    ClipboardIcon,
    FileTextIcon,
    TrashIcon,
    EditIcon
  },

  data() {
    return {
      page: 1,
      totalPages: 1,
      ElementPerPage: 20,
      sort: null,
      order: true,
      routes: {
        appspecificdata: "/api/appspecificdata",
        filter: "/api/appspecificdata/search/"
      },
      search: "",
      convertedTenants: [],
      tenantFilter: null,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
      rules: [(value) => !!value || this.$t("required")],
      appspecificdata: [],
      roles: [],
      createTenantPopup: false,
      menu: false,
      createmode: true,

      // Personal Data
      me: null,
    };
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },

  mounted() {
    this.fetchAppspecificData();
  },

  methods: {
    infiniteScrolling(entries, observer, isIntersecting) {
      if (isIntersecting) {
        setTimeout(() => {
          var _this = this;
          if (this.page < this.totalPages) {
            this.page++;
            this.$axios
              .get(this.routes.appspecificdata, {
                params: {
                  search: this.search,
                  sort: this.sort,
                  order: this.order ? "ASC" : "DESC",
                  page: this.page - 1,
                  size: this.ElementPerPage
                }
              })
              .then(function (response) {
                if (response.data.content.length >= 1) {
                  response.data.content.forEach(item => _this.appspecificdata.push(item));
                  _this.totalPages = response.data.totalPages;
                }
              })
              .catch(this.onError);
          }
        }, 500);
      }
    },
    // previousPage() {
    //   this.page = this.page - 1;
    //   this.fetchTenants();
    // },
    // nextPage() {
    //   this.page = this.page + 1;
    //   this.fetchTenants();
    // },
    onError(err) {
      if (
        err.response != null &&
        err.response.data != null &&
        err.response.data.message != null
      ) {
        this.$noty.error(err.response.data.message);
      } else {
        console.error(err);
      }
    },
    fetchAppspecificData(resetPage = false) {
      if (resetPage) this.page = 1;
      var _this = this;
      this.$axios
        .get(this.routes.appspecificdata,{
          params: {
            search: _this.search,
            sort: _this.sort,
            order: _this.order ? "ASC":"DESC",
            page: _this.page -1,
            size: _this.ElementPerPage
          }
        })
        .then(function (response) {
          _this.appspecificdata = response.data.content;
          _this.totalPages = response.data.totalPages;
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    updatePage() {
      this.fetchApps();
    },
    updateVisibleTenants() {
      var _this = this;
      this.tenants = this.tenants.slice(
        (_this.page = _this.ElementPerPage),
        (_this.page = _this.ElementPerPage) + _this.ElementPerPage
      );

      if (this.tenants.length == 0 && this.page > 0) {
        this.updatePage(this.page - 1);
      }
    },

    tableRowClicked(tenantId) {
      if (this.$rights.includes('EDIT_CUSTOMERS') || this.$rights.includes('TENANT_INDEPENDENCE')) {
        this.$router.push('/edit-tenant?tenantId=' + tenantId)
      }
    },
    getJsonOptions() {
      const options = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      return options;
    },
  },
};
</script>

<style scoped>
.v-dialog>.v-card>.v-card__actions {
  padding: 8px 16px;
}
</style>

